'use client';

import { c as _c } from "react/compiler-runtime";
import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';
import { cn } from '../../utils/cn';
function Progress(t0) {
  const $ = _c(12);
  let className;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      value,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = value;
  } else {
    className = $[1];
    props = $[2];
    value = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("bg-muted relative h-2 w-full overflow-hidden rounded-full", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = `translateX(-${100 - (value || 0)}%)`;
  let t3;
  if ($[6] !== t2) {
    t3 = <ProgressPrimitive.Indicator data-slot="progress-indicator" className="bg-primary h-full w-full flex-1 rounded-full transition-all" style={{
      transform: t2
    }} />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t3) {
    t4 = <ProgressPrimitive.Root data-slot="progress" className={t1} {...props}>{t3}</ProgressPrimitive.Root>;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { Progress };